import { render, staticRenderFns } from "./ViewFormRF07.vue?vue&type=template&id=78a832fd&scoped=true"
import script from "./ViewFormRF07.vue?vue&type=script&lang=js"
export * from "./ViewFormRF07.vue?vue&type=script&lang=js"
import style0 from "./ViewFormRF07.vue?vue&type=style&index=0&id=78a832fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a832fd",
  null
  
)

export default component.exports